import React from 'react';
import InputComponent from '../../components/input/input';
import ButtonComponent from '../../components/button/button';
import { useNavigate } from 'react-router-dom';
import DatePickerComponent from '../../components/input/input-date';
import { useUserData } from '../../shared/context/user-data-context';
import dayjs, { Dayjs } from 'dayjs';
import './styles.css';
import { MenuTop } from '../../components/menu/top/menu-top';

const Register = () => {
    const navigate = useNavigate();
    const [name, setName] = React.useState('');
    const [birthDate, setBirthDate] = React.useState<Dayjs | null>(null);
    const [idRegister, setIdRegister] = React.useState('');
    const { updateUserData } = useUserData();

    const handleNext = () => {

        if(name && birthDate && idRegister) {
            updateUserData({
                record_id: idRegister,
                nome: name,
                dtnasc: birthDate.format('DD/MM/YYYY')
            });

            navigate('/instruction');
        }

        return false;
    }

    return (
        <div>
            <div className='register-container'>
                <MenuTop /> 
                <img src="../../../assets/logo-inteira.png" alt="Logo delay discounting"  className="logo" style={{ width: '300px', height: '200px' }}/>
                <InputComponent 
                    id="id-register-input" 
                    label="Registro do usuário" 
                    value={idRegister} 
                    onChange={(event) => {setIdRegister(event.target.value)}} />


                <InputComponent 
                    id="name-input" 
                    label="Nome" 
                    value={name} 
                    onChange={(event) => {setName(event.target.value)}} />
                
                <DatePickerComponent 
                    label="Data de Nascimento"
                    value={birthDate}
                    onChange={(event) => {setBirthDate(event)}} />
                
                <ButtonComponent label="Registar" onClick={handleNext}/>
            </div>
        </div>
    )
}

export default Register;
